export default "__VITE_ASSET__DSfpDFew__"